import { Vue, Component, Prop } from 'vue-property-decorator'

import { FieldData } from '../../../../Pi/types'
import { TagData } from '../../../../Tags/types'
import { MessageSettingsData } from "../types"

@Component
export default class MessageSettingsProps extends Vue {
  @Prop({ type: Function }) readonly inputConfigFn!: (args: FieldData) => FieldData | undefined

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop() options?: { [key: string]: Array<TagData> }

  @Prop({ type: Object }) readonly settingsStructure!: MessageSettingsData
}
